import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return <div className='App text-black'>Tranzitech Admin Website </div>;
}

export default App;
